import { useAtomValue } from "jotai";
import { useQuery } from "@tanstack/react-query";

import { tenantIDAtom } from "../../../atoms/GlobalAtoms";
import TenantAPI from "../../api/TenantAPI";

interface useRecordsInterface {
  moduleAPIName?: string;
  disabled?: boolean;
  staleTime?: number;
}

const useRecords = ({
  moduleAPIName,
  disabled,
  staleTime,
}: useRecordsInterface) => {
  const tenantID = useAtomValue(tenantIDAtom);

  const records = useQuery({
    queryKey: [tenantID, "records", moduleAPIName],
    queryFn: () =>
      TenantAPI.getAllRecords(moduleAPIName!).then((data) => {
        return {
          records: data.data.data.data,
        };
      }),
    enabled: !!moduleAPIName && !disabled,
    staleTime: staleTime,
  });

  return {
    records: records.data?.records ?? [],
    recordsLoading: records.isLoading,
  };
};

export default useRecords;
